import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_3 = { class: "text-black font-medium" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white rounded-lg border border-gray-200 p-8 text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "bg-white rounded-lg border border-red-200 p-8 text-center"
}
const _hoisted_6 = { class: "text-red-600 mb-4" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "hidden md:block bg-white rounded-lg border border-gray-200 shadow-sm" }
const _hoisted_9 = { class: "flex items-center gap-3" }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["checked", "onChange"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "md:hidden space-y-3" }
const _hoisted_14 = { class: "flex justify-between items-start mb-3" }
const _hoisted_15 = { class: "font-semibold text-black" }
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["checked", "onChange"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "grid grid-cols-2 gap-2 text-sm" }
const _hoisted_21 = { class: "font-medium text-black" }
const _hoisted_22 = { class: "font-medium text-black" }
const _hoisted_23 = { class: "font-medium text-black" }
const _hoisted_24 = { class: "font-medium text-black" }
const _hoisted_25 = { class: "font-medium text-black" }
const _hoisted_26 = {
  key: 3,
  class: "bg-white rounded-lg border border-gray-200 p-8 text-center"
}
const _hoisted_27 = { class: "text-black" }

import { ActionButton, ReusableTable } from '@/components'
import type { Discount } from '@/types/discount'

interface Props {
  discounts: Discount[]
  isLoading: boolean
  error: string | null
  sectionTitle: string
  buttonLabel: string
  emptyMessage: string
  columns: Array<{ key: string; title: string; sortable: boolean; align?: string }>
}

interface Emits {
  (e: 'add'): void
  (e: 'retry'): void
  (e: 'delete', row: Discount): void
  (e: 'toggle-status', row: Discount): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DiscountSection',
  props: {
    discounts: {},
    isLoading: { type: Boolean },
    error: {},
    sectionTitle: {},
    buttonLabel: {},
    emptyMessage: {},
    columns: {}
  },
  emits: ["add", "retry", "delete", "toggle-status"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ActionButton), {
        label: _ctx.buttonLabel,
        icon: "fas fa-plus",
        variant: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add')))
      }, null, 8, ["label"]),
      _createElementVNode("span", _hoisted_3, ": " + _toDisplayString(_ctx.sectionTitle), 1)
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "flex items-center justify-center" }, [
            _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl text-black mr-3" }),
            _createElementVNode("span", { class: "text-black" }, "Chargement des remises...")
          ], -1)
        ])))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-exclamation-triangle text-2xl mb-2" }, null, -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('retry'))),
              class: "px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
            }, " Réessayer ")
          ]))
        : (_ctx.discounts.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(ReusableTable), {
                  columns: _ctx.columns,
                  data: _ctx.discounts,
                  sortable: true,
                  "show-edit": true,
                  "show-delete": true
                }, {
                  actions: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", {
                        class: "switch",
                        title: (row as unknown as Discount).actif === 'activé' ? 'Désactiver' : 'Appliquer'
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: (row as unknown as Discount).actif === 'activé',
                          onChange: _withModifiers(($event: any) => (_ctx.$emit('toggle-status', row as unknown as Discount)), ["stop"])
                        }, null, 40, _hoisted_11),
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "slider" }, null, -1))
                      ], 8, _hoisted_10),
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', row as unknown as Discount)), ["stop"]),
                        class: "w-8 h-8 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors flex items-center justify-center shadow-sm",
                        title: "Supprimer"
                      }, _cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "fas fa-trash text-sm" }, null, -1)
                      ]), 8, _hoisted_12)
                    ])
                  ]),
                  _: 1
                }, 8, ["columns", "data"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.discounts as unknown as Discount[]), (discount, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "bg-white rounded-lg border border-gray-200 shadow-sm p-4"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h4", _hoisted_15, _toDisplayString(discount.libelle || 'Sans titre'), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("label", {
                          class: "switch",
                          title: discount.actif === 'activé' ? 'Désactiver' : 'Appliquer'
                        }, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: discount.actif === 'activé',
                            onChange: _withModifiers(($event: any) => (_ctx.$emit('toggle-status', discount)), ["stop"])
                          }, null, 40, _hoisted_18),
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "slider" }, null, -1))
                        ], 8, _hoisted_17),
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', discount)), ["stop"]),
                          class: "w-8 h-8 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors flex items-center justify-center shadow-sm",
                          title: "Supprimer"
                        }, _cache[7] || (_cache[7] = [
                          _createElementVNode("i", { class: "fas fa-trash text-sm" }, null, -1)
                        ]), 8, _hoisted_19)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", null, [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-black" }, "Montant min", -1)),
                        _createElementVNode("p", _hoisted_21, _toDisplayString(discount.montantMin ?? 0), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-black" }, "Montant max", -1)),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(discount.montantMax ?? 0), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-black" }, "Date début", -1)),
                        _createElementVNode("p", _hoisted_23, _toDisplayString(discount.dateDebut || '-'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-black" }, "Date fin", -1)),
                        _createElementVNode("p", _hoisted_24, _toDisplayString(discount.dateFin || '-'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-black" }, "Taux", -1)),
                        _createElementVNode("p", _hoisted_25, _toDisplayString(discount.taux != null ? discount.taux + '%' : '0%'), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-percent text-4xl text-black mb-4" }, null, -1)),
              _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.emptyMessage), 1)
            ]))
  ]))
}
}

})